module.exports = __webpack_public_path__ + "img/sidebar_setting_active.43da1691.svg";